import type { AccessResult, MapAccessDeniedReason } from "@dailywars/core/entitlements/types";

export type { AccessResult };

function isUpgradeLockedReason(reason: MapAccessDeniedReason): boolean {
  return reason === "premium-required" || reason === "past-day-requires-premium";
}

export function mapAccessUiFlags(access: AccessResult | undefined): {
  canPlay: boolean;
  isUpgradeLocked: boolean;
  isNotReleased: boolean;
} {
  if (!access || access.ok) {
    return { canPlay: true, isUpgradeLocked: false, isNotReleased: false };
  }
  return {
    canPlay: false,
    isUpgradeLocked: isUpgradeLockedReason(access.reason),
    isNotReleased: access.reason === "not-released",
  };
}
